'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("lovService", function ($q, $http, $translate) {
  var lovs = {};

  /**
   *
   * @param lovName le nom de la lov. Possibilité de passé un paramètre via / (ex: syprospects/DETTE)
   * @param filterFunc
   * @param lovKeyComplement permet de fourni un complement à la clé de traduction ; key = lov.[lovName].[lovKeyComplement].[value]
   * @returns {function(): (*)}
   */
  var getLov = function getLov(lovName, filterFunc, lovKeyComplement) {
    return function () {
      if (_.has(lovs, lovName)) {
        return $q.resolve(lovs[lovName]);
      }
      return $http.get('/rest/lov/' + lovName).then(function (response) {
        var lov = _.map(response.data, function (val) {
          var lovNameSimple = lovName;
          // si le nom passé en paramètre contient '/', on retire le suffixe
          if (lovNameSimple.indexOf("/") !== -1) {
            lovNameSimple = lovNameSimple.substring(0, lovNameSimple.indexOf("/"));
          }
          var lovKey = 'lov.' + lovNameSimple;
          if (lovKeyComplement) {
            lovKey += "." + lovKeyComplement;
          }
          lovKey += '.' + val;
          return {
            id: val,
            label: $translate(lovKey)
          };
        });
        if (filterFunc) {
          lov = filterFunc(lov);
        }
        return lovs[lovName] = lov;
      }).catch(function (e) {
        console.error("impossible de recupérer la lov '" + lovName + "'", e);
        throw e;
      });
    };
  };

  /**
   * @returns liste des mois (Promise)
   *
   */
  var getMois = function getMois() {
    return [{
      id: 1,
      label: $translate("lov.mois.1")
    }, {
      id: 2,
      label: $translate("lov.mois.2")
    }, {
      id: 3,
      label: $translate("lov.mois.3")
    }, {
      id: 4,
      label: $translate("lov.mois.4")
    }, {
      id: 5,
      label: $translate("lov.mois.5")
    }, {
      id: 6,
      label: $translate("lov.mois.6")
    }, {
      id: 7,
      label: $translate("lov.mois.7")
    }, {
      id: 8,
      label: $translate("lov.mois.8")
    }, {
      id: 9,
      label: $translate("lov.mois.9")
    }, {
      id: 10,
      label: $translate("lov.mois.10")
    }, {
      id: 11,
      label: $translate("lov.mois.11")
    }, {
      id: 12,
      label: $translate("lov.mois.12")
    }];
  };
  _.set(lovs, 'mois', getMois());
  return {
    getStructuresGissler: getLov('structuresGissler'),
    getIndicesGissler: getLov('indicesGissler'),
    getTypesAmortissement: getLov('typesAmortissement'),
    getTypesAmortissementCDC: getLov('typesAmortissementCDC'),
    getPeriodicites: getLov('periodicites'),
    getPeriodicitesMasculin: getLov('periodicites', undefined, "masculin"),
    getBasesTaux: getLov('basesTaux', function (basesTaux) {
      return _.reject(basesTaux, function (baseTaux) {
        return _.includes(["BASE_THEORIQUE_30_360"], baseTaux.id);
      });
    }),
    getCalendriers: getLov('calendriers'),
    getTypesDeCotations: getLov('typesDeCotations'),
    getAjustementsDate: getLov('ajustementsDate'),
    getTypesFixing: getLov('typesFixing'),
    getTypesFlux: getLov('typesFlux'),
    getTypesDocuments: getLov('typesDocuments'),
    getTypesDocumentsAidesEtSubventions: getLov('typesDocuments/AidesEtSubventions'),
    getTypesDocumentsProduitsFinanciers: getLov('typesDocuments/ProduitsFinanciers'),
    getTypesDocumentsEcheancesProduitsFinanciers: getLov('typesDocuments/EcheancesProduitsFinanciers'),
    getTypesFrais: getLov('typesFrais'),
    getPeriodicitesOption: getLov('periodicitesOption'),
    getTypesPenaliteOptionRA: getLov("typesPenaliteOptionRA"),
    getTypesPenaliteActuarielle: getLov("typesPenaliteActuarielle"),
    getTauxPenaliteActuarielleIndex: getLov("tauxPenaliteActuarielleIndex"),
    getTypesPenaliteDegressive: getLov("typesPenaliteDegressive"),
    getTypesReglement: getLov("typesReglement"),
    getPlansComptables: getLov("plansComptables"),
    getLocales: getLov("locales"),
    getStatutsContrepartie: getLov('statutsContrepartie', function (statut) {
      return _.sortBy(statut, function (statut) {
        return statut.label;
      });
    }),
    getAffectations: getLov('affectations', function (affectations) {
      return _.sortBy(affectations, function (affectation) {
        return affectation.label;
      });
    }),
    getRoundingModes: getLov("roundingModes"),
    getTypesOptionTaux: getLov("typesOptionTaux"),
    getTypesIndicateurs: getLov("typesIndicateurs"),
    getFormatsIndicateurs: getLov("formatsIndicateurs"),
    getIndicateurOperations: getLov("indicateurOperations"),
    getTypesCompte: getLov("typesCompte"),
    getTimeUnits: getLov("timeUnits"),
    getNaturesBeneficiaires: getLov("naturesBeneficiaires"),
    getCategoriesBeneficiaires: getLov("categoriesBeneficiaires"),
    getLogiciels: getLov("logiciels"),
    getTaskStatuts: getLov("taskStatuts"),
    getTypeTickets: getLov("typeTickets"),
    getSensFlux: getLov("sensFlux"),
    getAjustementPeriodePaiement: getLov("ajustementPeriodePaiement"),
    getAjustementPeriodeFixing: getLov("ajustementPeriodeFixing"),
    getNaturesFlux: getLov("naturesFlux"),
    getApplicationsClients: getLov("applicationsClients"),
    getReglesCalageDate: getLov("reglesCalageDate"),
    getTypeRevisions: getLov("typeRevisions"),
    getTypesIndemniteRA: getLov("typesIndemniteRA"),
    getMois: getLov("mois"),
    getPays: getLov("pays"),
    // crm
    getTypesFacture: getLov("typesFacture"),
    getCrmTypesClient: getLov("crmTypesClient"),
    getCrmBureaux: getLov("crmBureaux"),
    getCrmTypesContrat: getLov("crmTypesContrat"),
    getCrmContratDocumentType: getLov("crmContratDocumentType"),
    // sytale
    getSyProspectStatut: getLov("syProspectStatut"),
    getSyEtapeCommerciale: getLov("syEtapeCommerciale"),
    getSyNatureOffre: getLov("syNatureOffre"),
    getSyTypeOffre: getLov("syTypeOffre"),
    getSyTypeActionActivite: getLov("syTypeActionActivite"),
    getSyFonctionMetier: getLov("syFonctionMetier"),
    getNdfNature: getLov("ndfNature"),
    getNdfStatut: getLov("ndfStatut"),
    getTypeRecommandationProduits: getLov("typeRecommandationProduits"),
    getCompteSuiviStatuts: getLov("compteSuiviStatuts"),
    getSyPrestataires: getLov("syPrestataires"),
    getSyPrestatairesDette: getLov("syPrestataires/DETTE"),
    getSyPrestatairesProspective: getLov("syPrestataires/PROSPECTIVE"),
    getSyPrestatairesGestionFinanciere: getLov("syPrestataires/GESTION_FINANCIERE"),
    getSyProspectTags: getLov("syProspectTags"),
    getActiviteTypes: getLov("activiteTypes"),
    getPricingObligataireMethodes: getLov("pricingObligataireMethodes"),
    getCategoryComptes: getLov("categoryComptes"),
    getPublicationTypes: getLov("publicationTypes"),
    getCadrages: getLov('cadrages'),
    getFormationModalites: getLov('formationModalites'),
    getTypesVersementSubvention: getLov("typesVersementSubvention"),
    getMarketDatasources: getLov("marketDatasources"),
    getTypeFinanceurSubventions: getLov("typeFinanceurSubventions"),
    getValidationStates: getLov("validationStates"),
    getStatutValidationProduits: getLov("statutValidationProduit"),
    /**
     * @returns Attention ce n'est pas une Promise
     */
    getTypeTauxProgression: function getTypeTauxProgression() {
      return [{
        id: false,
        label: "Périodique"
      }, {
        id: true,
        label: "Annuel"
      }];
    },
    /**
     * @returns Attention ce n'est pas une Promise
     */
    getTrueFalse: function getTrueFalse() {
      return [{
        id: true,
        label: 'Oui'
      }, {
        id: false,
        label: 'Non'
      }];
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/services/lovService.js
// module id = 2877
// module chunks = 13